import React, { useId, forwardRef } from 'react';
import clsx from 'clsx';

interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(({
  label,
  error,
  className,
  id,
  ...props
}, ref) => {
  const generatedId = useId();
  const textareaId = id || generatedId;

  return (
    <div className="textarea-wrapper">
      {label && (
        <label htmlFor={textareaId} className="textarea-label">
          {label}
        </label>
      )}
      <textarea
        ref={ref}
        id={textareaId}
        className={clsx('textarea', error && 'textarea--error', className)}
        {...props}
      />
      {error && <span className="textarea-error">{error}</span>}
    </div>
  );
});

Textarea.displayName = 'Textarea';

